/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleFilterViewModel } from "../types/ClassModuleFilterViewModel.ts";

export const classModuleFilterViewModelSchema = z.object({
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  companyId: z.number().int().nullish(),
  description: z.string().nullish(),
  dateStart: z.string().datetime().nullish(),
  dateFinish: z.string().datetime().nullish(),
  classStudentId: z.number().int().nullish(),
}) as unknown as ToZod<ClassModuleFilterViewModel>;
